import React from "react";
import ButtonHome from '../ButtonHome';
import ButtonStoryAdd from '../ButtonStoryAdd';
import ButtonLoginOrProfile from '../ButtonLoginOrProfile';
import './index.scss';

export default function ButtonPanelReaction({ className = '' }) {
	return (
		<nav className={`footer-button footer-button--main ${className}`.trim()}>
			<ButtonHome />
			<ButtonStoryAdd />
			<ButtonLoginOrProfile />
		</nav>
	)
}
